import React, {FC} from 'react';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps, ResolveStateProps} from '../../../helpers/reselectHelpers';
import {getUser} from '../../../store/data/teammates/teammatesSelectors';
import {getActiveHelpChatConfig, makeGetAppPanel} from '../../../store/panels/app/appPanelSelectors';
import {AppPanelId} from '../../../store/panels/panelStateBase';
import {HelpChat} from './helpChat';

/*
 * Props.
 */

interface HelpChatContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

function makeGetHelpChatOpenAttempt() {
  return createSelector(makeGetAppPanel(), (appPanel) => appPanel.helpChatOpenAttempt);
}

/*
 * Component.
 */

const HelpChatContainerComponent: FC<ResolveStateProps<typeof mapStateToProps>> = (props) => {
  const {activeHelpChatConfig} = props;
  if (!activeHelpChatConfig) {
    return null;
  }

  return <HelpChat {...props} helpChatConfig={activeHelpChatConfig} />;
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<HelpChatContainerProps>()(() => ({
  user: getUser,
  activeHelpChatConfig: getActiveHelpChatConfig,
  helpChatOpenAttempt: makeGetHelpChatOpenAttempt(),
}));

export const HelpChatContainer = connect(mapStateToProps)(HelpChatContainerComponent);
